<template>
  <Transition :name="toastAnimation">
    <Message
      v-if="toastStore.state"
      class="component w-fit! max-w-[754px] border z-1000 [word-break:break-word]"
      :class="classes"
      :type="toastStore.state.type"
    >
      {{ toastStore.state?.content }}
    </Message>
  </Transition>
</template>

<script setup lang="ts">
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { computed } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'
import { Message } from '@dacr/ui'

const device = useDevice()
const toastStore = useToastStore()

const classes = computed(() => ({
  'border-gray-800/30': toastStore.state?.type === ToastType.Default,
  'border-green-200/50': toastStore.state?.type === ToastType.Success,
  'border-yellow-700/40': toastStore.state?.type === ToastType.Warning,
  'border-red-200/50': toastStore.state?.type === ToastType.Error,
}))

const toastAnimation = computed(() =>
  device.isMobile.value || device.isTabletVertical.value
    ? 'toast-mobile'
    : 'toast'
)
</script>

<style scoped>
.component {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.05);
}
</style>
